<template>
	<div>
		<v-subheader class="text-xs-left">Current</v-subheader>
		<v-data-table disable-initial-sort :headers="headers" :items="currentPositions" hide-actions class="elevation-1 position-list">
			<template slot="items" slot-scope="props">
				<tr :class="{ 'grayed-out-row': isGrayedOutRow(props.item) }">
					<td style="width: 1px;">
						<v-tooltip v-if="showStatusDot(props.item)" bottom>
							<v-icon slot="activator" small :color="getStatusDotColor(props.item)">mdi-circle</v-icon>
							<span>{{ getStatusDotTooltip(props.item) }}</span>
						</v-tooltip>
					</td>
					<td class="text-xs-left">
						<router-link :to="{ name: 'employeePosition', params: { employeeId, id: props.item.id } }">
							{{ props.item.title }}
						</router-link>
					</td>
					<td class="text-xs-left">{{ getPositionTypeFriendly(props.item.type) }}</td>
					<td class="text-xs-left">
						<router-link v-if="props.item.reportsTo" :to="{ name: 'employee', params: { employeeId, id: props.item.reportsTo.id } }">
							{{ props.item.reportsTo.fullName }}
						</router-link>
						<div v-else>
							N/A
						</div>
					</td>
					<td class="text-xs-left">{{ props.item.startDateUTC | formatDate() }}</td>
					<td class="text-xs-left py-2">
						<v-chip small :outline="getStatusChipOutline(props.item.status)" :color="getStatusChipColor(props.item.status)" :text-color="getStatusChipTextColor(props.item.status)">{{ getStatusFriendly(props.item.status) }}</v-chip>
						<div v-if="isApprovedPendingAcknowledgement(props.item)" class="info-text mt-1 ml-1">
							<v-icon color="warning" small>mdi-alert-circle-outline</v-icon>
							PD awaiting employee acknowledgement <span v-if="showSendToEmployeeButton(props.item)"> | <a @click="onSendPositionToEmployee(props.item)" style="font-style: normal;">Send to employee for acknowledgement</a></span>
						</div>
						<div v-else-if="isLive(props.item) && !isAcknowledgedBySystemAdmin(props.item)" class="info-text mt-1 ml-1">
							<v-icon color="success" small>mdi-check-circle-outline</v-icon> Acknowledged by {{ getAcknowledgedBy(props.item) }} on {{ props.item.employeeAcknowledgement.acknowledgementDateUtc | formatDate }}
						</div>
					</td>
					<td class="text-xs-right px-0">
						<v-btn small v-if="showApproveButton(props.item)" color="primary" class="mr-3" @click="onApprove(props.item)">Approve</v-btn>

						<v-icon v-if="canEdit" small class="mr-2" @click="onEditClick(props.item)">
							edit
						</v-icon>

						<v-menu>
							<template #activator="{ on: menu }">
								<v-tooltip bottom>
									<template #activator="{ on: tooltip }">
										<v-icon v-on="{ ...tooltip, ...menu }" small class="mr-2">
											more_vert
										</v-icon>
									</template>
									<span>More Options</span>
								</v-tooltip>
							</template>
							<v-list>
								<v-list-tile @click="onSendPosition(props.item)"><v-list-tile-title>Email Position</v-list-tile-title></v-list-tile>
								<v-list-tile v-if="loggedInEmployee.isAdmin" @click="convertToTemplateClick(props.item)"><v-list-tile-title>Convert Position to Template</v-list-tile-title></v-list-tile>
								<v-list-tile v-if="canEdit" small @click="deletePosition(props.item)"><v-list-tile-title>Delete Position</v-list-tile-title></v-list-tile>
							</v-list>
						</v-menu>
					</td>
				</tr>
			</template>
		</v-data-table>

		<div v-if="archivedPositions.length > 0">
			<div v-if="!showArchiveList" class="mt-3 text-xs-right">
				<a class="font-italic" @click="showArchiveList = true">View archived ({{ archivedPositions.length }})</a>
			</div>
			<div v-else>
				<v-subheader class="text-xs-left mt-3">
					Archive<v-spacer />
					<a class="ml-2 font-italic" @click="showArchiveList = false">Hide Archived</a>
				</v-subheader>
				<v-data-table disable-initial-sort :headers="headers" :items="archivedPositions" hide-actions class="elevation-1 position-list">
					<template slot="items" slot-scope="props">
						<tr :class="{ 'grayed-out-row': isGrayedOutRow(props.item) }">
							<td style="width: 1px;">
								<v-tooltip v-if="showStatusDot(props.item)" bottom>
									<v-icon slot="activator" small :color="getStatusDotColor(props.item)">mdi-circle</v-icon>
									<span>{{ getStatusDotTooltip(props.item) }}</span>
								</v-tooltip>
							</td>
							<td class="text-xs-left">
								<router-link :to="{ name: 'employeePosition', params: { employeeId, id: props.item.id } }">
									{{ props.item.title }}
								</router-link>
							</td>
							<td class="text-xs-left">{{ getPositionTypeFriendly(props.item.type) }}</td>
							<td class="text-xs-left">
								<router-link v-if="props.item.reportsTo" :to="{ name: 'employee', params: { employeeId, id: props.item.reportsTo.id } }">
									{{ props.item.reportsTo.fullName }}
								</router-link>
								<div v-else>
									N/A
								</div>
							</td>
							<td class="text-xs-left">{{ props.item.startDateUTC | formatDate() }}</td>
							<td class="text-xs-left py-2">
								<v-chip small outline :color="getStatusChipColor(props.item.status)">{{ props.item.status == 10 ? 'Previous' : getStatusFriendly(props.item.status) }}</v-chip>
								<div v-if="isApprovedPendingAcknowledgement(props.item)" class="info-text mt-1 ml-1">
									<v-icon color="warning" small>mdi-alert-circle-outline</v-icon>
									PD awaiting employee acknowledgement <span v-if="showSendToEmployeeButton(props.item)"> | <a @click="onSendPositionToEmployee(props.item)" style="font-style: normal;">Send to employee for acknowledgement</a></span>
								</div>
								<div v-else-if="isLive(props.item) && !isAcknowledgedBySystemAdmin(props.item)" class="info-text mt-1 ml-1">
									<v-icon color="success" small>mdi-check-circle-outline</v-icon> Acknowledged by {{ getAcknowledgedBy(props.item) }} on {{ props.item.employeeAcknowledgement.acknowledgementDateUtc | formatDate }}
								</div>
							</td>
							<td class="text-xs-right px-0">
								<v-btn small v-if="showApproveButton(props.item)" color="primary" class="mr-3" @click="onApprove(props.item)">Approve</v-btn>

								<v-icon v-if="canEdit" small class="mr-2" @click="onEditClick(props.item)">
									edit
								</v-icon>

								<v-menu>
									<template #activator="{ on: menu }">
										<v-tooltip bottom>
											<template #activator="{ on: tooltip }">
												<v-icon v-on="{ ...tooltip, ...menu }" small class="mr-2">
													more_vert
												</v-icon>
											</template>
											<span>More Options</span>
										</v-tooltip>
									</template>
									<v-list>
										<v-list-tile @click="onSendPosition(props.item)"><v-list-tile-title>Email Position</v-list-tile-title></v-list-tile>
										<v-list-tile v-if="canEdit" small @click="deletePosition(props.item)"><v-list-tile-title>Delete Position</v-list-tile-title></v-list-tile>
									</v-list>
								</v-menu>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</div>

		<ConvertPositionToTemplateDialog v-if="showConvertToTemplateDialog" :dialog="showConvertToTemplateDialog" :position="positionToConvert" @closeDialog="showConvertToTemplateDialog = false" />

		<confirmation-dialog
			v-if="showConfirmEditDialog"
			:dialog="showConfirmEditDialog"
			:text="confirmEditDialogText"
			title="Information"
			confirmButtonText="Proceed"
			@onConfirm="editPosition(positionToEdit)"
			@onCancel="showConfirmEditDialog = false"
		/>
	</div>
</template>

<script>
	import EmployeePositionEditor from '@/components/employee/EmployeePositionEditor';
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';
	import positionStatusMixin from '@/mixins/positionStatusMixin';
	import ConvertPositionToTemplateDialog from '@/components/employee/ConvertPositionToTemplateDialog';

	export default {
		components: {
			EmployeePositionEditor,
			ConvertPositionToTemplateDialog
		},
		mixins: [typeFriendlyMixin, positionStatusMixin],
		props: {
			employeeId: {
				required: true,
				type: String
			},
			positions: {
				required: true,
				type: Array
			},
			showArchive: {
				required: false,
				type: Boolean
			},
			loggedInEmployee: {
				required: true,
				type: Object
			}
		},
		data() {
			return {
				headers: [
					{ text: '', value: 'statusDot' },
					{ text: 'Title', value: 'title' },
					{ text: 'Position Type', value: 'type' },
					{ text: 'Reports To', value: 'reportsTo' },
					{ text: 'Effective Date', value: 'startDateUTC' },
					{ text: 'Status', value: 'status' },
					{ text: '', value: 'actions', sortable: false }
				],
				showArchiveList: this.showArchive,
				positionToEdit: null,
				showConfirmEditDialog: false,
				showConvertToTemplateDialog: false,
				positionToConvert: null
			};
		},
		computed: {
			positionsSorted() {
				return this.positions.sort((a, b) => {
					if (new Date(b.startDateUTC) > new Date(a.startDateUTC)) return 1;
					else if (new Date(b.startDateUTC) < new Date(a.startDateUTC)) return -1;

					return a.status - b.status;
				});
			},
			currentPositions() {
				if (!this.areThereAnyLive(this.positionsSorted)) return [...this.positionsSorted];

				return this.positionsSorted.filter(x => this.isDraft(x) || !this.areThereNewerLive(x, this.positionsSorted));
			},
			archivedPositions() {
				if (!this.areThereAnyLive(this.positionsSorted)) return [];

				return this.positionsSorted.filter(x => !this.isDraft(x) && this.areThereNewerLive(x, this.positionsSorted));
			},
			confirmEditDialogText() {
				if (!this.positionToEdit) return null;

				if (this.isApproved(this.positionToEdit) && this.isAcknowledged(this.positionToEdit)) {
					return `This position is already live. A new draft will be created for any changes that are saved.`;
				} else if (this.isApproved(this.positionToEdit)) {
					return `This position has already been approved by <strong>${this.positionToEdit.approval.approvedBy.fullName}</strong>. Any changes made to the position will reset the status back to <strong>Draft</strong>.`;
				}

				return null;
			},
			canEdit() {
				const isUnderling = this.loggedInEmployee.underlings != null && this.loggedInEmployee.underlings.includes(this.employeeId);
				return this.loggedInEmployee.isAdmin || isUnderling;
			},
			isLoggedInEmployee() {
				return this.loggedInEmployee.id === this.employeeId;
			}
		},
		methods: {
			convertToTemplateClick(position) {
				this.showConvertToTemplateDialog = true;
				this.positionToConvert = position;
			},
			onEditClick(position) {
				this.editPosition(position);
			},
			editPosition(item) {
				this.showConfirmEditDialog = false;
				this.$emit('onEditPosition', item);
			},
			deletePosition(item) {
				this.$emit('onDeletePosition', item);
			},
			showStatusDot(position) {
				//return !this.areThereNewerLive(position);
				return true;
			},
			getStatusDotColor(position) {
				if (this.isDraft(position) || this.isApprovedPendingAcknowledgement(position)) return 'warning';
				else if (this.areThereNewerLive(position, this.positionsSorted)) return 'grey lighten-1';
				else if (this.isLive(position)) return 'success';
				return '';
			},
			getStatusDotTooltip(position) {
				if (!this.isApproved(position)) return 'PD not yet approved';
				else if (!this.isAcknowledged(position)) return 'PD awaiting employee acknowledgement';
				else if (this.areThereNewerLive(position, this.positionsSorted)) return 'Previous';
				else if (this.isLive(position)) return 'PD is Live';
				return '';
			},
			isGrayedOutRow(position) {
				return this.areThereNewerLive(position, this.positionsSorted);
			},
			canApprove() {
				// Only managers & admins can approve
				if (this.loggedInEmployee.isAdmin) {
					return true;
				}

				// Employees cannot approve their own
				if (this.loggedInEmployee.id === this.employeeId) {
					return false;
				}

				if (this.loggedInEmployee.underlings != null) {
					return this.loggedInEmployee.underlings.includes(this.employeeId);
				}
			},
			showApproveButton(position) {
				if (position.approval != null) {
					return false;
				}
				return this.canApprove() && !this.areThereNewerLive(position, this.positionsSorted);
			},
			showSendToEmployeeButton(position) {
				return this.isApprovedPendingAcknowledgement(position) && !this.isLoggedInEmployee;
			},
			onApprove(position) {
				this.$emit('onApprovePosition', position);
			},
			onSendPositionToEmployee(position) {
				this.$emit('onSendPositionToEmployee', position);
			},
			onSendPosition(position) {
				this.$emit('onSendPosition', position);
			}
		}
	};
</script>

<style>
	.position-list table thead tr th:first-child,
	.position-list table tbody tr td:first-child,
	.position-list table thead tr th:nth-child(2),
	.position-list table tbody tr td:nth-child(2) {
		padding-left: 15px;
		padding-right: 0;
	}
</style>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}
	.grayed-out-row {
		opacity: 0.7;
	}
</style>
